/**
 * Full page reload.
 *
 * Its own module so a component can be tested without jsdom's unmockable
 * `window.location.reload`.
 */
export const reloadPage = (): void => window.location.reload()
